import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import { Action, projectSubject, useAppAbility } from "common/access";
import { useAuth } from "../../contexts/AuthContext";
import { CreateProjectCreditsPanel } from "../CreateProjectCreditsPanel";

export const DashboardPageHeader = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const ability = useAppAbility();

  const canCreate = useMemo(
    () =>
      ability.can(
        Action.Create,
        projectSubject({ organizationId: user?.organizationId }),
      ),
    [ability, user?.organizationId],
  );

  return (
    <div className="-mx-6 -mt-4 flex flex-col gap-4 border-b border-indigo-100 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 px-6 py-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-center gap-3">
        <div className="grid h-10 w-10 flex-shrink-0 place-items-center rounded-lg bg-gradient-to-br from-indigo-600 to-blue-500 text-white shadow-sm">
          <Building2 size={20} />
        </div>
        <div>
          <h2 className="text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
            {t("dashboard.your_construction_projects")}
          </h2>
          <p className="mt-0.5 text-sm text-slate-500">
            {canCreate
              ? t("dashboard.create_projects_description")
              : t("dashboard.view_projects_description")}
          </p>
        </div>
      </div>
      <CreateProjectCreditsPanel />
    </div>
  );
};
